var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "margin-top-3x" }, [
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
        ])
      : _c("div", { staticClass: "row margin-top-4x" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              { staticClass: "margin-top-2x" },
              [
                _c("div", { staticClass: "table-responsive" }, [
                  _vm.parkguard_reservations && _vm.parkguard_reservations.data
                    ? _c(
                        "table",
                        {
                          staticClass:
                            "table table-striped table-sm parkguard-reservations"
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              (_vm.parkguard_reservations &&
                                _vm.parkguard_reservations.data) ||
                                [],
                              function(item, index) {
                                return _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          item.created_at,
                                          "MM/DD/YYYY hh:mm A"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.reservation_number))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    item.pg_identifiers
                                      ? _c(
                                          "div",
                                          [
                                            _c("json-viewer", {
                                              attrs: {
                                                value: item.pg_identifiers
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    item.reference_numbers
                                      ? _c(
                                          "div",
                                          [
                                            _c("json-viewer", {
                                              attrs: {
                                                value: item.reference_numbers
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.customer_email))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(item.first_name) +
                                        " " +
                                        _vm._s(item.last_name)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.phone_number))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(item.car_make) +
                                        " " +
                                        _vm._s(item.car_model) +
                                        " " +
                                        _vm._s(item.car_year)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          item.start_date,
                                          "MM/DD/YYYY"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.start_time))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          item.end_date,
                                          "MM/DD/YYYY"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.end_time))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    item.split_intervals
                                      ? _c(
                                          "div",
                                          [
                                            _c("json-viewer", {
                                              attrs: {
                                                value: item.split_intervals
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm.heightOverSplitIntervals(index)
                                              ? _c(
                                                  "span",
                                                  {
                                                    class: [
                                                      "ellipsis-btn",
                                                      "ellipsis-btn-split-" +
                                                        index
                                                    ],
                                                    attrs: {
                                                      id:
                                                        "ellipsis-btn-split-" +
                                                        index,
                                                      title:
                                                        "click to show hidden items"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showHiddenSplitIntervals(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-double-down",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(item.parking_street_address) +
                                        " - " +
                                        _vm._s(item.parking_city) +
                                        " - " +
                                        _vm._s(item.parking_state) +
                                        " - " +
                                        _vm._s(item.parking_zipcode)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.protection_plan_name))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.protection_base_price))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.protection_total_price_per_interval
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.protection_total_price))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.protection_markup_price))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.channel_commission))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.reslab_commission))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.channel_markup_type))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.channel_markup_value))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.reslab_fee_type))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(item.reslab_fee_value))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.currency))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.status))])
                                ])
                              }
                            ),
                            0
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.parkguard_reservations &&
                _vm.parkguard_reservations.last_page
                  ? _c("pagination", {
                      attrs: {
                        "pages-number": _vm.parkguard_reservations.last_page
                      },
                      on: {
                        pageChanged: function(page) {
                          return _vm.loadParkguardReservations(page)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Created at")]),
        _vm._v(" "),
        _c("th", [_vm._v("Res #")]),
        _vm._v(" "),
        _c("th", [_vm._v("pg identifiers")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reference numbers")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Phone")]),
        _vm._v(" "),
        _c("th", [_vm._v("Car Data")]),
        _vm._v(" "),
        _c("th", [_vm._v("StartDate")]),
        _vm._v(" "),
        _c("th", [_vm._v("Start Time")]),
        _vm._v(" "),
        _c("th", [_vm._v("End Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("End Time")]),
        _vm._v(" "),
        _c("th", [_vm._v("Split intervals")]),
        _vm._v(" "),
        _c("th", [_vm._v("Address")]),
        _vm._v(" "),
        _c("th", [_vm._v("Protection Plan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Base price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total price per interval")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total price")]),
        _vm._v(" "),
        _c("th", [_vm._v("Markup amount")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab commission")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Channel markup value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab fee type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Reslab fee value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Currency")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a15a8a40", { render: render, staticRenderFns: staticRenderFns })
  }
}